
import { Component, Vue, Prop } from 'vue-property-decorator'
import CAudioCard from '@/components/cards/audio-card'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'
import addProtocol from '@/@next/helpers/addProtocol'
import { smallerImageUrl } from '@/@next/helpers'

const config = {
  name: 'c-content-audio',
  components: {
    ...CAudioCard,
    CImage,
    CLoader
  }
}

@Component(config)
export default class CContentAudio extends Vue {
  @Prop({ type: Object, required: true }) content!: any

  get audio () {
    return this.content?.data.i18n.audio?.value || null
  }

  get title () {
    return this.content?.data?.i18n?.title?.value || null
  }

  get description () {
    return this.content?.data.i18n.description?.value || null
  }

  get image () {
    return this.content?.data.i18n.audio?.value?.image  || null
  }

  get backUpUrl () {
    if (!this.image) return null
    const url = smallerImageUrl(this.image)
    if (!url) return null
    return addProtocol(url)
  }

}
